import React, { Component, SyntheticEvent } from "react";
import { connect } from "react-redux";
import Sidebar from "containers/sidebar";
import NoInterviews from "containers/interviews/no-interviews";
import SubscriptionSelect from "shared/helpers/subscription-select";
import Tabs from "components/controls/tabs";
import debounce from "lodash.debounce";
import InterviewItem from "containers/interviews/interview-item";
import InvalidateInterviewModal from "containers/interviews/invalidate-interview-modal";
import ChangeModeratorModal from "containers/interviews/change-moderator-modal";
import SearchBar from "components/controls/search-bar";
import { capitalizeFirstLetter } from "shared/helpers/functional";
import TimeSlotManagementModal from "containers/scheduler/timeslot-management-modal";
import {
  localizedDateFormatter,
  getUserTimeZone,
  localizedTranslate,
} from "assets/localization";
import { propEq, find, ascend, descend, prop, pathOr } from "ramda";
import { isModerator, isPMOrAdmin, isQSAdmin } from "shared/helpers/user";
import ProjectFilter from "containers/scheduler/project-filter";
import PaymentStatusFilter from "containers/scheduler/payment-status-filter";
import "less/profile.less";
import Topbar from "containers/project/topbar";
import { Spinner } from "@blueprintjs/core";
import CombinedAvailabilityWarningModal from "containers/scheduler/combined-availability-warning-modal";
import EditIncentiveModal from "containers/interviews/edit-incentive-modal";
import CreditIncentiveModal from "containers/interviews/credit-incentive-modal";
import BulkIncentive from "containers/interviews/bulk-incentive";

const getActiveTab = (tabs) => find(propEq("active", true))(tabs).value;

class Interviews extends Component {
  isPMOrAdmin = isPMOrAdmin();
  isQSAdmin = isQSAdmin();
  isModerator =
    isModerator() || this.props.roles.includes("QUAL_SCHEDULER_MODERATOR");
  // Prevent repeated bottom-trigger fetches during modal scroll
  scrollLock = false;
  state = {
    tabs: [
      {
        display: "Upcoming Interviews",
        value: "upcoming",
        active: true,
      },
      {
        display: "Completed Interviews",
        value: "completed",
        active: false,
      },
      {
        display: "Invalidated Interviews",
        value: "invalidate",
        active: false,
      },
    ],
    linksArray: [
      {
        display: "Interviews",
        icon: "im-ic-interview",
        path: "/interviews",
      },
      {
        display: this.isPMOrAdmin ? "All Moderator Calendar" : "My Schedule",
        icon: this.isPMOrAdmin ? "im-calendar-all-moderator" : "im-calendar",
        path: "/moderator/schedule",
        className: this.isPMOrAdmin ? "all-moderator-schedule" : "",
      },
      {
        display: "Profile",
        icon: "im-ss-user",
        path: "/profile",
      },
    ],
    // For reopening Invalidate modal after reschedule back
    invalidateModalOpen: false,
    invalidateModalData: undefined,
    changeModeratorModalOpen: false,
    changeModeratorModalData: undefined,
    showLoader: false,
    isInvalidateReschedule: false
  };

  openChangeModerator = (interview) => {
    this.setState({
      changeModeratorModalOpen: true,
      changeModeratorModalData: interview,
    });
    this.props.fetchAvailableModerators({ timeSlotId: interview.timeSlotId });
  };

  debouncedSearch = debounce(this.props.fetchInterviewsList, 400);

  componentDidMount() {
    // get interviews when component mounts with selected clients and account
     if (this.isModerator && !this.isPMOrAdmin) {
      this.props.user.userId &&
        this.props.fetchInterviewsList(this.props.user.userId, true);
    }
    if (this.isPMOrAdmin) {
      let linksArr = this.state.linksArray.slice();
      linksArr.splice(0, 0, {
        display: "Projects",
        icon: "im-ss-inboxes",
        path: "/projects",
      });
      linksArr.splice(3, 0, {
        display: "Moderator Management",
        icon: "im-user2",
        path: "/moderatorManagement/schedule",
        className: "all-moderator-schedule",
      });
      this.isQSAdmin &&
        linksArr.splice(4, 0, {
          display: "User Management",
          path: "/userManagement",
          className: "user-management",
        });
      this.setState({ linksArray: linksArr });
    }
    if (this.isModerator) {
      if (
        (isModerator &&
          (this.props.roles.includes("QUAL_SCHEDULER_MANAGER") ||
            this.props.roles.includes("QUAL_SCHEDULER_ADMIN"))) ||
        (isPMOrAdmin && this.props.roles.includes("QUAL_SCHEDULER_MODERATOR"))
      ) {
        this.props.user.userId &&
          this.props.fetchProjects({
            moderatorId: this.props.user.userId,
            clientId: this.props.clientId,
          });
      }
      if (!this.props.projectsList[this.props.clientId])
        this.props.user.userId &&
          this.props.fetchProjects({
            moderatorId: this.props.user.userId,
            clientId: this.props.clientId,
          });
      else this.fillItems();
    } else {
      if (!this.props.projectsList[this.props.clientId])
        this.props.user.userId &&
          this.props.fetchProjects({ clientId: this.props.clientId });
      else this.fillItems();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.projectsList !== this.props.projectsList ||
      prevProps.moderatorList !== this.props.moderatorList
    ) {
      this.fillItems();
    }

    if (prevProps.user.userId !== this.props.user.userId) {
      if (this.isModerator) {
        this.props.fetchInterviewsList(this.props.user.userId, true);
        this.props.fetchProjects({
          moderatorId: this.props.user.userId,
          clientId: this.props.clientId,
        });
      } else {
        console.log(">>> Interviews componentDidUpdate: userId changed", prevProps.user.userId, "→", this.props.user.userId)
        this.props.fetchInterviewsList(this.props.user.userId, true);
        this.props.fetchProjects({ clientId: this.props.clientId });
      }
    }

    if (prevProps.isLoading && !this.props.isLoading && this.state.showLoader) {
      this.setState({ showLoader: false });
    }

    if (
      prevProps.creditIncentiveState.bulkIncentiveModeEnabled !==
        this.props.creditIncentiveState.bulkIncentiveModeEnabled &&
      this.props.creditIncentiveState.bulkIncentiveModeEnabled &&
      !["PAST_DUE", "NOT_CREDITED"].includes(this.props.paymentStatusCode)
    ) {
      this.props.setPaymentStatusFilter({ paymentStatusCode: "NOT_CREDITED" });
      this.debouncedSearch();
    }
  }
  handelScroll = (event) => {
    // Avoid background infinite-scroll when any modal is open
    if (
      this.props.timeSlotModalOpen ||
      this.state.invalidateModalOpen ||
      this.props.warningModalOpen ||
      (this.props.editIncentiveModal && this.props.editIncentiveModal.isOpen) ||
      (this.props.creditIncentiveModal &&
        this.props.creditIncentiveModal.isOpen)
    ) {
      return;
    }
    if (this.isPMOrAdmin) {
      const activeTab = getActiveTab(this.props.tabs);
      const scrollHeight = event.target.scrollHeight;
      const currentHeight = Math.ceil(
        event.target.scrollTop + event.target.clientHeight,
      );
      if (currentHeight + 1 >= scrollHeight && event.target.scrollTop) {
        if (this.scrollLock) return;
        this.scrollLock = true;
        this.debouncedSearch({
          offset: 0,
          isPMOrAdmin: true,
          flag: activeTab,
        });
        setTimeout(() => {
          this.scrollLock = false;
        }, 800);
      }
    }
  };

  fillItems = () => {
    let itemIds = new Set();
    let itemsValues = [];

    if (this.props.projectsList) {
      this.props.projectsList[this.props.clientId].forEach((project) => {
        if (!itemIds.has(project.id)) {
          itemsValues.push({
            value: project.id,
            label: project.name,
          });
          itemIds.add(project.id);
        }
      });
    }
    this.props.setItemsValues(itemsValues);
  };

  fetchInterviews = () => {
    this.debouncedSearch();
  };

  sortInterviews = (currentTabValue, interviews) => {
    if (currentTabValue === "invalidate") {
      return interviews.sort(descend(prop("updatedOn")));
    }
    const sortDir = currentTabValue === "upcoming" ? ascend : descend;
    return interviews.sort(sortDir(prop("endTime")));
  };

  tabClick = (value) => {
    this.setState({ showLoader: true });
    this.props.updateFilters({ q: "" });
    if (value === "upcoming") {
      this.props.setPaymentStatusFilter({ paymentStatusCode: "ALL" });
      this.debouncedSearch();
    } else if (value === "invalidate") {
      this.debouncedSearch();
    } else if (value === "completed") {
      this.debouncedSearch();
    }
    const sortedInterviews = this.sortInterviews(
      value,
      this.props.interviewsList,
    );
    this.props.setTabs(
      this.props.tabs.map((tab) =>
        Object.assign({}, tab, { active: value === tab.value }),
      ),
    );
    this.props.setFormattedInterviews(sortedInterviews);
  };

  selectAll = () => {
    this.props.updateFilters({ filteredItems: new Set() });
    this.debouncedSearch();
  };

  clearAll = () => {
    const newFileteredItems = new Set(
      this.props.itemsValues.map(({ value: id }) => id),
    );
    this.props.updateFilters({ filteredItems: newFileteredItems });
    this.debouncedSearch();
  };

  changeHandler = ({ value: id }) => {
    const filteredItems = new Set(this.props.filteredItems);
    filteredItems.has(id) ? filteredItems.delete(id) : filteredItems.add(id);
    this.props.updateFilters({ filteredItems: filteredItems });
    this.debouncedSearch();
  };

  interviewToTimeSlot = (interview) => {
    return {
      timeSlotId: interview.timeSlotId,
      startTime: interview.startTime,
      projectId: interview.projectId,
      intervieweeId: interview.participantId,
      endTime: interview.endTime,
      projectName: interview.projectName,
      surveyNamePrivate: interview.surveyNamePrivate,
      isInvalidateEmailSent: interview.isInvalidateEmailSent,
    };
  };

  showManagementModal = (interview, chosenAction, i) => {
    const timeSlot = this.interviewToTimeSlot(interview);
    if (interview.importedOverLap === "0") {
    this.setState({ timeSlot, chosenAction }, () =>
        this.props.toggleModal(timeSlot.timeSlotId),
    );
    } else if (interview.importedOverLap === "1") {
      this.setState({ timeSlot: timeSlot, chosenAction });
      this.props.toggleCombinedAbWarningModal(timeSlot);
    }
  };

  toggleModal = () => {
    this.setState({ timeSlot: undefined, chosenAction: undefined }, () =>
      this.props.toggleModal(0),
    );
  };

  openRescheduleFromInvalidate = (interview, selected) => {
    const mapCodeToReason = (code) => {
      const normalized = String(code || "").toUpperCase();
      if (normalized === "PARTICIPANT_NO_SHOW") return "participant_no_show";
      if (normalized === "MODERATOR_NO_SHOW") return "moderator_no_show";
      if (normalized === "OTHER" || normalized === "OTHERS") return "other";
      return undefined;
    };
    const fallbackReason = mapCodeToReason(
      interview && interview.invalidationReasonCode,
    );
    const fallbackSelected = fallbackReason
      ? {
          reason: fallbackReason,
          otherReason:
            fallbackReason === "other"
              ? interview && interview.invalidationReasonText
              : undefined,
        }
      : undefined;
    const invalidateModalData = {
      projectName: `${interview.projectName} #${interview.externalSurveyId}`,
      participantId: interview.participantId,
      startTime: interview.startTime,
      endTime: interview.endTime,
      timeZone: this.props.userTimezone,
      moderatorName: `${interview.firstName} ${interview.lastName}`,
      interview,
      // Preserve any prior or newly provided selection so the Invalidate modal can restore state
      selected:
        selected ||
        (this.state.invalidateModalData
          ? this.state.invalidateModalData.selected
          : undefined) ||
        fallbackSelected,
    };
    this.setState({ invalidateModalData, invalidateModalOpen: false }, () =>
      this.showManagementModal(interview, "reschedule"),
    );
  };

  handleBackFromReschedule = () => {
    // Close the reschedule modal and reopen invalidate modal (reconstruct if needed)
    const existing = this.state.invalidateModalData;
    const fromCompleted = this.state.invalidateThenRescheduleData;

    let nextInvalidateData = existing;
    if (!nextInvalidateData && fromCompleted && fromCompleted.interview) {
      const interview = fromCompleted.interview;
      const selected = fromCompleted.selected;
      // Rebuild invalidate modal data from completed-tab reschedule context
      nextInvalidateData = {
        projectName: `${interview.projectName} #${interview.externalSurveyId}`,
        participantId: interview.participantId,
        startTime: interview.startTime,
        endTime: interview.endTime,
        timeZone: this.props.userTimezone,
        moderatorName: `${interview.firstName} ${interview.lastName}`,
        interview,
        selected,
      };
    }

    if (nextInvalidateData) {
      this.setState(
        {
          invalidateModalData: nextInvalidateData,
          invalidateModalOpen: true,
          chosenAction: undefined,
        },
        () => {
          this.props.toggleModal(0);
        },
      );
    } else {
      // Fallback: just reset modal
      this.setState({ chosenAction: undefined }, () => {
        this.props.toggleModal(0);
      });
    }
  };

  filterItem = (filteredItems) => (interview) =>
    this.isModerator
      ? !filteredItems.has(interview.projectId)
      : !filteredItems.has(interview.moderatorId);

  updateAndFilter = (q = "") => {
    this.props.updateFilters({ q: q });
    this.debouncedSearch();
  };

  handlePaymentStatusChange = (selectedOption) => {
    const status = selectedOption.value;
    this.props.setPaymentStatusFilter({ paymentStatusCode: status });
    if (["CREDITED", "ALL"].includes(status))
      this.props.disableBulkIncentiveMode();
    this.debouncedSearch();
  };

  handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const timePassed = (time) => time.getTime() <= Date.now();
    const selectedIds = isChecked
      ? this.props.formattedInterviews
          .filter((interview) =>
            Boolean(
              parseInt(
                interview.customHonorariumAmount ||
                  interview.defaultHonorariumAmount,
              ) && timePassed(interview.endTime),
            ),
          )
          .map((interview) => interview.timeSlotId)
      : [];
    this.props.setBulkSelectedTimeSlots(selectedIds);
  };

  handleSelectInterview = (timeSlotId) => {
    const selectedIds = new Set(
      this.props.creditIncentiveState.selectedTimeSlotIds,
    );
    if (selectedIds.has(timeSlotId)) {
      selectedIds.delete(timeSlotId);
    } else {
      selectedIds.add(timeSlotId);
    }
    this.props.setBulkSelectedTimeSlots([...selectedIds]);
  };

  render() {
    const before = (time) => time.getTime() <= Date.now();
    const after = (time) => time.getTime() > Date.now();
    const activeTabObj = find(propEq("active", true))(this.props.tabs);
    const activeTab = activeTabObj
      ? activeTabObj.value
      : getActiveTab(this.props.tabs);
    const isCompleted = activeTab === "completed";
    const predicate = activeTab === "upcoming" ? after : before;
    let displayedInterviews = this.props.formattedInterviews
      .filter((interview) => {
        return predicate(interview.endTime);
      })
      .map((interview, i) => (
        <InterviewItem
          {...interview}
          Ineligible={interview.Ineligible}
          history={this.props.history}
          isCompleted={isCompleted}
          showPreviousNoShow={
            activeTab === "upcoming" || activeTab === "completed" || activeTab === "invalidate"
          }
          activeTab={activeTab}
          key={i}
          manageInterview={() => this.showManagementModal(interview)}
          rescheduleInterview={(selected) =>
            this.openRescheduleFromInvalidate(interview, selected)
          }
          openRescheduleDirect={(selected) => {
            // Store selection for Completed tab invalidate-then-reschedule flow
            const invalidateThenRescheduleData = { interview, selected };
            this.setState({ isInvalidateReschedule: true });
            this.setState({ invalidateThenRescheduleData }, () =>
              this.showManagementModal(interview, "reschedule"),
            );
          }}
          invalidateInterview={(payload) =>
            this.props.invalidateInterview({
              ...payload,
              timeSlotId: interview.timeSlotId,
              projectName: interview.projectName,
              externalSurveyId: interview.externalSurveyId,
            })
          }
          openChangeModerator={() => this.openChangeModerator(interview)}
          formatDate={this.props.formatDate}
          timeZone={this.props.userTimezone}
          showInvalidatedPill={activeTab === "invalidate"}
          openEditIncentiveModal={this.props.openEditIncentiveModal}
          openCreditIncentiveModal={this.props.openCreditIncentiveModal}
          showCheckbox={Boolean(
            isCompleted &&
            interview.paymentStatus !== "CREDITED" &&
            this.props.creditIncentiveState.bulkIncentiveModeEnabled &&
            parseInt(
              interview.customHonorariumAmount ||
                interview.defaultHonorariumAmount,
            ),
          )}
          isSelected={this.props.creditIncentiveState.selectedTimeSlotIds.includes(
            interview.timeSlotId,
          )}
          onSelect={() => this.handleSelectInterview(interview.timeSlotId)}
          isPmOrAdmin={isPMOrAdmin()}
          t={this.props.t}
        />
      ));
    return (
      <div onScroll={this.handelScroll} className="top-level-content-wrap">
        {<Sidebar links={this.state.linksArray} />}
        <div id="profile" className="top-level-content">
          <Topbar
            {...this.props}
            urlPath={""}
            shareHash={""}
            title={"Interviews"}
          />
          <div className="interviews-container">
            <Tabs
              tabs={this.props.tabs}
              onClick={this.tabClick}
              className="interview-tabs"
            />
            <div
              className={`list-container ${
                this.props.forPreview ? "preview" : ""
              }`}
            >
              <div className="interview-filters">
                <div className="list-name">
                  <div className="name">
                    {(activeTabObj && activeTabObj.display) ||
                      `${capitalizeFirstLetter(activeTab)} Interviews`}
                  </div>
                </div>
                <div className="flex-form">
                  <SearchBar
                    onChange={(e) =>
                      this.updateAndFilter(e.currentTarget.value)
                    }
                    value={this.props.q}
                  />

                  <div className="filter-toggles">
                    <label
                      className="text control-label"
                      htmlFor="status"
                    ></label>
                    <ProjectFilter
                      collection={this.props.itemsValues}
                      filteredItems={this.props.filteredItems}
                      collectionToFilter={"Projects"}
                      onSelectAll={this.selectAll}
                      onClearAll={this.clearAll}
                      onChange={this.changeHandler}
                      icon={`${
                        this.isModerator ? "im-ss-inboxes" : "im-user2"
                      }`}
                    />
                  </div>

                  {isCompleted && (
                    <PaymentStatusFilter
                      filteredItems={this.props.filteredPaymentStatuses}
                      filterSelected={true}
                      onSelectAll={this.selectAllStatuses}
                      onClearAll={this.clearAllStatuses}
                      onChange={this.handlePaymentStatusChange}
                      selectedOption={this.props.paymentStatusCode}
                    />
                  )}
                </div>
              </div>
              {isCompleted && isPMOrAdmin() && (
                <BulkIncentive
                  t={this.props.t}
                  selectedTimeSlotIds={
                    this.props.creditIncentiveState.selectedTimeSlotIds
                  }
                  handleSelectAll={this.handleSelectAll}
                  isSelectAllChecked={
                    this.props.creditIncentiveState.selectedTimeSlotIds
                      .length &&
                    this.props.creditIncentiveState.selectedTimeSlotIds
                      .length ===
                      this.props.formattedInterviews.filter((interview) =>
                        Boolean(
                          parseInt(
                            interview.customHonorariumAmount ||
                              interview.defaultHonorariumAmount,
                          ) && predicate(interview.endTime),
                        ),
                      ).length
                  }
                />
              )}
              {this.props.isLoading || this.state.showLoader ? (
                <Spinner intent="primary" className="overlay-spinner" />
              ) : displayedInterviews.length === 0 ? (
                <NoInterviews
                  tab={getActiveTab(this.props.tabs)}
                  isModerator={this.isModerator}
                />
              ) : (
                displayedInterviews
              )}
            </div>
          </div>
        </div>
        {/* Page-level submitting overlay */}
        {this.props.editSessionIsSending && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255,255,255,0.6)",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spinner intent="primary" />
          </div>
        )}
        {this.props.timeSlotModalOpen && (
          <TimeSlotManagementModal
            isOpen={this.props.timeSlotModalOpen}
            timeSlot={this.state.timeSlot}
            forAdmin={true}
            formatDate={this.props.formatDate}
            chosenAction={this.state.chosenAction}
            invalidateReschedule={Boolean(this.state.invalidateModalData)}
            isInvalidateReschedule={this.state.isInvalidateReschedule}
            onInvalidateRescheduleRevert={() => this.setState({ isInvalidateReschedule: false })}
            invalidateSelected={
              this.state.invalidateModalData &&
              this.state.invalidateModalData.selected
            }
            invalidateThenReschedule={Boolean(
              this.state.invalidateThenRescheduleData,
            )}
            invalidateSelectedFromCompleted={
              this.state.invalidateThenRescheduleData &&
              this.state.invalidateThenRescheduleData.selected
            }
            onBack={this.handleBackFromReschedule}
            toggleModal={this.toggleModal}
            onClose={() =>
              this.setState({ cancelOrRescheduleAction: undefined })
            }
            onSave={() => this.fetchInterviews(this.props.user.userId)}
            hideBackButton={activeTab === "invalidate"}
          />
        )}
        {this.state.changeModeratorModalData && (
          <ChangeModeratorModal
            isOpen={this.state.changeModeratorModalOpen}
            onClose={() => this.setState({ changeModeratorModalOpen: false })}
            onConfirm={(newModeratorId) => {
              const interview = this.state.changeModeratorModalData;
              this.props.changeModerator({
                timeSlotId: interview.timeSlotId,
                newModeratorId,
                onSave: () => {
                  this.setState({ changeModeratorModalOpen: false });
                  this.fetchInterviews(this.props.user.userId);
                },
              });
            }}
            projectName={this.state.changeModeratorModalData.projectName}
            participantId={this.state.changeModeratorModalData.participantId}
            startTime={this.state.changeModeratorModalData.startTime}
            endTime={this.state.changeModeratorModalData.endTime}
            timeZone={this.props.userTimezone}
            currentModeratorName={this.state.changeModeratorModalData.isProjectModerator ? "Project Moderator" : "Global Moderator"}
            availableModerators={this.props.availableModerators}
            loading={this.props.availableModeratorsLoading}
            submitting={this.props.changeModeratorLoading}
            formatDate={this.props.formatDate}
            t={this.props.t}
          />
        )}
        {this.state.invalidateModalData && (
          <InvalidateInterviewModal
            isOpen={this.state.invalidateModalOpen}
            origin={"interviews"}
            onClose={() => this.setState({ invalidateModalOpen: false })}
            onConfirm={({ action, reason, otherReason }) => {
              if (action === "invalidate_and_reschedule") {
                const { interview } = this.state.invalidateModalData;
                this.setState(
                  {
                    invalidateModalOpen: false,
                    invalidateModalData: {
                      ...this.state.invalidateModalData,
                      selected: { action, reason, otherReason },
                    },
                  },
                  () =>
                    this.openRescheduleFromInvalidate(interview, {
                      action,
                      reason,
                      otherReason,
                    }),
                );
              } else {
                const { interview } = this.state.invalidateModalData;
                this.setState(
                  {
                    invalidateModalOpen: false,
                    invalidateModalData: {
                      ...this.state.invalidateModalData,
                      selected: { action, reason, otherReason },
                    },
                  },
                  () => {
                    this.props.invalidateInterview({
                      timeSlotId: interview.timeSlotId,
                      projectName: interview.projectName,
                      externalSurveyId: interview.externalSurveyId,
                      origin: "interviews",
                      reason,
                      otherReason,
                    });
                  },
                );
              }
            }}
            projectName={this.state.invalidateModalData.projectName}
            participantId={this.state.invalidateModalData.participantId}
            startTime={this.state.invalidateModalData.startTime}
            endTime={this.state.invalidateModalData.endTime}
            timeZone={this.state.invalidateModalData.timeZone}
            moderatorName={this.state.invalidateModalData.moderatorName}
            t={this.props.t}
            formatDate={this.props.formatDate}
            initialReschedule={
              this.state.invalidateModalData.selected
                ? this.state.invalidateModalData.selected.action ===
                  "invalidate_and_reschedule"
                : true
            }
            initialReason={
              this.state.invalidateModalData.selected
                ? this.state.invalidateModalData.selected.reason
                : undefined
            }
            initialOtherReason={
              this.state.invalidateModalData.selected
                ? this.state.invalidateModalData.selected.otherReason
                : undefined
            }
          />
        )}
        {this.props.warningModalOpen && (
          <CombinedAvailabilityWarningModal
            isOpen={this.props.warningModalOpen}
            onClose={this.props.toggleCombinedAbWarningModal}
            onSubmit={this.props.toggleModal}
            timeSlot={this.state.timeSlot}
            toggleCombinedAbWarningModal={
              this.props.toggleCombinedAbWarningModal
            }
            toggleTimeSlotPopover={this.props.toggleTimeSlotPopover}
            t={this.props.t}
          />
        )}
        {this.props.editIncentiveModal.isOpen && (
          <EditIncentiveModal
            onBack={
              Boolean(this.state.invalidateModalData)
                ? this.handleBackFromReschedule
                : undefined
            }
            onClose={this.props.closeEditIncentiveModal}
            timeSlotId={this.props.editIncentiveModal.timeSlotId}
            initialIncentive={this.props.editIncentiveModal.initialIncentive}
            incentive={this.props.editIncentiveModal.incentive}
            enableSubmit={this.props.editIncentiveModal.enableSubmit}
            currency={this.props.editIncentiveModal.currency}
            t={this.props.t}
          />
        )}
        {this.props.creditIncentiveModal.isOpen && (
          <CreditIncentiveModal
            isOpen={this.props.creditIncentiveModal.isOpen}
            onClose={this.props.closeCreditIncentiveModal}
            timeSlotId={this.props.creditIncentiveModal.timeSlotId}
            incentive={this.props.creditIncentiveModal.incentive}
            currency={this.props.creditIncentiveModal.currency}
            t={this.props.t}
          />
        )}
      </div>
    );
  }
}

const mapState = (state) => ({
  formatDate: localizedDateFormatter("en", getUserTimeZone(state)),
  timeSlotModalOpen: state.scheduler.timeSlotModalOpen,
  clientId: state.client.clientId,
  projectsList: state.projectList.byClientId,
  moderatorList: state.moderatorList.moderatorList,
  noModerators: state.moderatorList.noModerators,
  roles: state.login.roles,
  filteredClients: state.user.filteredClients,
  interviewsList: state.interviewsList.interviewsList,
  availableModerators: state.interviewsList.availableModerators,
  availableModeratorsLoading: state.interviewsList.availableModeratorsLoading,
  changeModeratorLoading: state.interviewsList.changeModeratorLoading,
  formattedInterviews: state.interviewsList.formattedInterviews,
  filteredInterviews: state.interviewsList.filteredInterviews,
  q: state.interviewsList.q,
  filteredItems: state.interviewsList.filteredItems,
  itemsValues: state.interviewsList.itemsValues,
  accountsSelected: state.login.accountsSelected,
  clientsSelected: state.login.clientsSelected,
  isLoading: state.interviewsList.isLoading,
  tabs: state.interviewsList.tabs,
  userTimezone: getUserTimeZone(state),
  user: state.user,
  warningModalOpen: state.scheduler.warningModalOpen,
  t: localizedTranslate("en", state.translations.en_us),
  paymentStatusCode: state.interviewsList.paymentStatusCode,
  editIncentiveModal: state.ui.editIncentiveModal,
  creditIncentiveModal: state.ui.creditIncentiveModal,
  creditIncentiveState: state.creditIncentiveReducer,
  editSessionIsSending: state.editSession.isSending,
  isInvalidateReschedule: state.isInvalidateReschedule
});

const mapDispatch = {
  toggleModal: (timeSlotId) => ({
    type: "TOGGLE_TIMESLOT_MODAL",
    payload: { timeSlotId, fetchAll: true },
  }),
  toggleCombinedAbWarningModal: (payload) => ({
    type: "TOGGLE_IMP_AVA_WARNING_MODAL",
    payload,
  }),
  fetchProjects: (payload) => ({
    type: "FETCH_ALL_PROJECTS_REQUESTED",
    payload,
  }),
  fetchModeratorsList: (payload) => ({
    type: "FETCH_ALL_MODERATORS_REQUESTED",
    payload,
  }),
  fetchInterviewsList: (payload) => ({
    type: "FETCH_INTERVIEWS_LIST_REQUESTED",
    payload,
  }),
  setFormattedInterviews: (payload) => ({
    type: "SET_FORMATTED_INTERVIEWS",
    payload,
  }),
  setFilteredInterviews: (payload) => ({
    type: "SET_FILTERED_INTERVIEWS",
    payload,
  }),
  updateFilters: (payload) => ({ type: "UPDATE_INTERVIEWS_FILTERS", payload }),
  setItemsValues: (payload) => ({ type: "SET_ITEMS_VALUES", payload }),
  setTabs: (payload) => ({ type: "SET_TABS", payload }),
  fetchPaymentStatusList: () => ({
    type: "FETCH_INTERVIEW_PAYMENT_STATUS_REQUESTED",
  }),
  setPaymentStatusFilter: (payload) => ({
    type: "SET_PAYMENT_STATUS_FILTER",
    payload,
  }),
  openEditIncentiveModal: (payload) => ({
    type: "OPEN_EDIT_INCENTIVE_MODAL",
    payload,
  }),
  closeEditIncentiveModal: () => ({ type: "CLOSE_EDIT_INCENTIVE_MODAL" }),
  fetchIncentiveUpdateReasonsList: () => ({
    type: "FETCH_INCENTIVE_UPDATE_REASONS_REQUESTED",
  }),
  updateIncentive: (payload) => ({
    type: "UPDATE_INCENTIVE_REQUESTED",
    payload,
  }),
  openCreditIncentiveModal: (payload) => ({
    type: "OPEN_CREDIT_INCENTIVE_MODAL",
    payload,
  }),
  closeCreditIncentiveModal: () => ({ type: "CLOSE_CREDIT_INCENTIVE_MODAL" }),
  creditIncentive: (payload) => ({
    type: "CREDIT_INCENTIVE_REQUESTED",
    payload,
  }),
  setBulkSelectedTimeSlots: (payload) => ({
    type: "SET_BULK_SELECTED_TIME_SLOTS",
    payload,
  }),
  disableBulkIncentiveMode: () => ({ type: "BULK_INCENTIVE_MODE_DISABLED" }),
  invalidateInterview: (payload) => ({
    type: "INVALIDATE_INTERVIEW_REQUESTED",
    payload,
  }),
  fetchAvailableModerators: (payload) => ({
    type: "FETCH_AVAILABLE_MODERATORS_REQUESTED",
    payload,
  }),
  changeModerator: (payload) => ({
    type: "REASSIGN_MODERATOR_REQUESTED",
    payload,
  }),
};

export default connect(mapState, mapDispatch)(Interviews);
